export const FEATURE_PDF = true;
export const FEATURE_PDP_SSG = false;
export const FEATURE_TABLE_HEADER_TOOLTIP = false;
